// extracted by mini-css-extract-plugin
export default {"scroll_menus-category":"ScrollBarCat_scroll_menus-category__1UQeb"};